<template>
<div class="app">
    <b-container fluid class="md-content">
        <div class="md-header">Abwesenheiten & Wünsche</div>
        
        <b-card no-body>
            <b-tabs card>
                <b-tab title="Abwesenheiten & Wünsche" active>
                    <b-row>
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createemployeepreference')">Wunsch/Urlaub/Präferenz anlegen</b-button>
                        </b-col>
                        <b-col>
                            <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row v-if="employeepreferences != undefined">
                        <b-col>
                            <b-table bordered :items="employeepreferences" :fields="fields">
                                <template slot="stateLabel" slot-scope="row">
                                    <p v-if="employeeAvailabilityStateMap[row.item.state] != null"> {{employeeAvailabilityStateMap[row.item.state].label_de}}</p>
                                </template>
                                <template slot="typeLabel" slot-scope="row">
                                    <p v-if="row.item.type != null && employeeAvailabilityTypeMap[row.item.type] != null"> {{employeeAvailabilityTypeMap[row.item.type].label_de}}</p>
                                </template>
                                <template slot="workValueLabel" slot-scope="row">
                                    <p v-if="row.item.workValue != null"> {{row.item.workValue}} Minuten</p>
                                </template>
                                <template slot="actions" slot-scope="row">
                                    <b-button class="mx-1" size="sm" v-on:click="openPublishModal(row.item.id)"><i class="fas fa-arrow-alt-circle-up"></i></b-button>
                                    <b-button class="mx-1" size="sm" v-on:click="openViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                                    <b-button class="mx-1" size="sm" v-on:click="openEditModal(row.item.id)"><i class="fas fa-pencil-alt"></i></b-button>
                                    <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row.item.id)"><i class="fas fa-trash"></i></b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Abwesenheiten & Wünsche-Änderungen">
                    <b-row>
                        <b-col>
                            <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row v-if="preferenceChanges != undefined">
                        <b-col>
                            <b-table bordered :items="preferenceChanges" :fields="preferenceChangeTableFields">
                                <template slot="changes" slot-scope="row">
                                    <p v-for="item in row.item.changes" v-bind:key="item.label">{{item.label}}: {{item.newValue}}</p>
                                </template>
                                <template slot="actions" slot-scope="row">
                                    <b-button class="mx-1" size="sm" variant="success" v-on:click="openApprovePreferenceChangeModal(row.item.id)"><i class="fas fa-check-circle"></i></b-button>
                                    <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeletePreferenceChangeModal(row.item.id)"><i class="fas fa-trash"></i></b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
            
        </b-card>
    </b-container>

    <b-modal ref="modal-viewemployeepreference"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Abwesenheit/Wunsch Detail" @cancel="hideModal('modal-viewemployeepreference')" @ok="hideModal('modal-viewemployeepreference')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Schicht" active>
                    <div v-if="employeePreferenceMap[employeePreferenceId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Position:</b> 
                            </b-col>
                            <b-col>
                                <p v-if="!$helpers.isBlank(employeePreferenceMap[employeePreferenceId].spotId)">{{spotMap[employeePreferenceMap[employeePreferenceId].spotId].name}}</p>
                            </b-col>
                            <b-col class="md-2">
                                <b>Mitarbeiter:</b> 
                            </b-col>
                            <b-col>
                                <p v-if="!$helpers.isBlank(employeePreferenceMap[employeePreferenceId].employeeId)">{{employeeMap[employeePreferenceMap[employeePreferenceId].employeeId].firstName}} {{employeeMap[employeePreferenceMap[employeePreferenceId].employeeId].lastName}}</P>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Von:</b> 
                            </b-col>
                            <b-col>
                                {{employeePreferenceMap[employeePreferenceId].from}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bis:</b> 
                            </b-col>
                            <b-col>
                                {{employeePreferenceMap[employeePreferenceId].to}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Status:</b> 
                            </b-col>
                            <b-col>
                                {{employeeAvailabilityStateMap[employeePreferenceMap[employeePreferenceId].state].label_de}}
                            </b-col>
                            <b-col class="md-2" v-if="employeePreferenceMap[employeePreferenceId].type != null">
                                <b>Typ:</b> 
                            </b-col>
                            <b-col v-if="employeePreferenceMap[employeePreferenceId].type != null">
                                {{employeeAvailabilityTypeMap[employeePreferenceMap[employeePreferenceId].type].label_de}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2" v-if="employeePreferenceMap[employeePreferenceId].workValue != null">
                                <b>Arbeitszeit:</b> 
                            </b-col>
                            <b-col v-if="employeePreferenceMap[employeePreferenceId].workValue != null">
                                {{employeePreferenceMap[employeePreferenceId].workValue}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Überschreibt Verfügbarkeit:</b> 
                            </b-col>
                            <b-col>
                                {{employeePreferenceMap[employeePreferenceId].overrideContract}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Wichtigkeit:</b> 
                            </b-col>
                            <b-col>
                                {{employeePreferenceMap[employeePreferenceId].factor}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Kommentar:</b> 
                            </b-col>
                            <b-col>
                                {{employeePreferenceMap[employeePreferenceId].comment}}
                            </b-col>
                        </b-row>
                        
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-createemployeepreference"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Abwesenheit/Wunsch anlegen" @cancel="hideModal('modal-createemployeepreference')" @ok="createEmployeePreference" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Position Begrenzung" label-for="ce1">
                    <b-form-select id = "ce1" v-model="employeePreference.spotId">
                        <option v-bind:value="null">
                            Keine Position Begrenzung
                        </option>
                         <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter" label-for="ce2">
                    <b-form-select id = "ce2" v-model="employeePreference.employeeId">
                        <option v-bind:value="null">
                            Kein Mitarbeiter
                        </option>
                         <option v-for="option in employeeMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.lastName }} {{ option.firstName }} 
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Status" label-for="createstate">
                    <b-form-select id = "upstate" v-model="employeePreference.state">
                        <option v-for="item in uiData.employeeAvailabilityStates" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Typ" label-for="createtype" v-if="employeePreference.state == 1">
                    <b-form-select id = "uptype" v-model="employeePreference.type">
                        <option v-for="item in uiData.employeeAvailabilityTypes" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Arbeitszeit" label-for="createworkvalue" v-if="employeePreference.state == 1">
                    <b-form-input id="createworkvalue" min=0 v-model.number="employeePreference.workValue" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wichtigkeit" label-for="ce9" v-if="employeePreference.state === 3 || employeePreference.state === 4">
                    <b-form-input id="ce9" min=1 max = 10 v-model.number="employeePreference.factor" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Datum von" label-for="ce4">
                    <b-form-input id="ce4" v-model="employeePreference.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="ce5">
                    <b-form-input id="ce5" v-model="employeePreference.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Datum bis" label-for="ce6">
                    <b-form-input id="ce6" v-model="employeePreference.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="ce7">
                    <b-form-input id="ce7" v-model="employeePreference.toTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Überschreibt Verfügbarkeit" label-for="cs7">
                    <b-form-checkbox id="cs7" v-model="employeePreference.overrideContract">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Kommentar" label-for="cs8">
                    <b-form-input id="cs8" v-model="employeePreference.comment" type="text"></b-form-input>
                </b-form-group>

               
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-editemployeepreference"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Abwesenheit/Wunsch bearbeiten" @cancel="hideModal('modal-editemployeepreference')" @ok="updateEmployeePreference" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Position Begrenzung" label-for="up1">
                    <b-form-select id = "up1" v-model="employeePreferenceUpdate.spotId">
                        <option v-bind:value="null">
                            Keine Position Begrenzung
                        </option>
                         <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Status" label-for="upstate">
                    <b-form-select id = "upstate" v-model="employeePreferenceUpdate.state">
                        <option v-for="item in uiData.employeeAvailabilityStates" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Typ" label-for="uptype" v-if="employeePreferenceUpdate.state == 1">
                    <b-form-select id = "uptype" v-model="employeePreferenceUpdate.type">
                        <option v-for="item in uiData.employeeAvailabilityTypes" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Arbeitszeit" label-for="upworkvalue" v-if="employeePreferenceUpdate.state == 1">
                    <b-form-input id="upworkvalue" min=0 v-model.number="employeePreferenceUpdate.workValue" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wichtigkeit" label-for="ce9" v-if="employeePreferenceUpdate.state === 3 || employeePreferenceUpdate.type === 4">
                    <b-form-input id="ce9" min=1 max=10 v-model.number="employeePreferenceUpdate.factor" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Datum von" label-for="up3">
                    <b-form-input id="up3" v-model="employeePreferenceUpdate.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="up4">
                    <b-form-input id="up4" v-model="employeePreferenceUpdate.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Datum bis" label-for="up5">
                    <b-form-input id="up5" v-model="employeePreferenceUpdate.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="up6">
                    <b-form-input id="up6" v-model="employeePreferenceUpdate.toTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Überschreibt Verfügbarkeit" label-for="up7">
                    <b-form-checkbox id="up7" v-model="employeePreferenceUpdate.overrideContract">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Kommentar" label-for="up8">
                    <b-form-input id="up8" v-model="employeePreferenceUpdate.comment" type="text"></b-form-input>
                </b-form-group>

            </div>
            
            <b-row v-if="error">
                Fehler beim Ändern.
            </b-row>
        </b-container>
    </b-modal>

    
    <b-modal ref="modal-deleteemployeepreference"  no-close-on-backdrop no-close-on-esc centered title="Abwesenheit/Wunsch löschen" @cancel="hideModal('modal-deleteemployeepreference')" @ok="deleteEmployeePreference" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Präferenz löschen wollen?</p>
            </b-row>

            <b-row v-if="error" class="my-1">
                Fehler beim Löschen der Präferenz.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-publishemployeepreference"  no-close-on-backdrop no-close-on-esc centered title="Abwesenheit/Wunsch bestätigen" @cancel="hideModal('modal-publishemployeepreference')" @ok="approveEmployeePreference" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Präferenz bestätigen wollen?</p>
            </b-row>
            <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Einhaltung garantieren" label-for="certain">
                    <b-form-checkbox id="certain" v-model="approveCertain">
                    </b-form-checkbox>
            </b-form-group>
            <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wichtigkeit" label-for="appf" v-if="!approveCertain">
                    <b-form-input id="appf" min=1 max=10 v-model.number="factor" type="number"></b-form-input>
            </b-form-group>
            <b-row v-if="error" class="my-1">
                Fehler beim Bestätigen der Präferenz.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-approvepreferencechange"  no-close-on-backdrop no-close-on-esc centered title="Abwesenheit/Wunsch Änderung bestätigen" @cancel="hideModal('modal-approvepreferencechange')" @ok="approvePreferenceChange" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Präferenz Änderung durchführen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Durchführen der Präferenz Änderung.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deletepreferencechange"  no-close-on-backdrop no-close-on-esc centered title="Abwesenheit/Wunsch Änderung löschen" @cancel="hideModal('modal-deletepreferencechange')" @ok="deletePreferenceChange" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Präferenz Änderung entfernen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Löschen der Präferenz Änderung.
            </b-row>
        </b-container>
    </b-modal>

  </div>

</template>

<script>
export default {
  name: 'employeepreferenceoverview',
  data () {
    return {
      uiData: {},
      employeeAvailabilityStateMap: {},
      employeeAvailabilityTypeMap: {},
      spotMap: {},
      employeeMap: {},
      employeePreferenceMap: {},
      preferenceChangeMap: {},
      preferenceChanges: [],
      employeepreferences: [],
      fields: [{key:"spot", label:"Position", sortable: true},{key:"employee", label:"Mitarbeiter", sortable: true}, {key:"stateLabel", label:"Status", sortable: true}, 
               {key:"typeLabel", label:"Typ", sortable: true}, {key:"from", label:"Von", sortable: true},{key:"to", label:"Bis", sortable: true},
               {key:"workValueLabel", label:"Arbeitszeit", sortable: true},{key:"factor", label:"Wichtigkeit", sortable: true}, {key:"approved", label:"Bestätigt", sortable: true},
               {key:"actions", sortable: false}], 
      preferenceChangeTableFields: [{key:"changeDate", label:"Änderungsdatum", sortable: true},{key:"spot", label:"Position", sortable: true},{key:"employee", label:"Mitarbeiter", sortable: true}, {key:"from", label:"Von", sortable: true},
                               {key:"to", label:"Bis", sortable: true},{key:"approved", label:"Bestätigt", sortable: true},{key:"changes", label:"Änderungen", sortable: true},{key:"actions", sortable: false}],
      employeePreference: {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          factor: 1,
          state: 1,
          type: 4,
          workValue: 0,
          overrideContract: true,
          comment: null
          
      },
      employeePreferenceUpdate: {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          factor: 1,
          state: 1,
          type: 4,
          workValue: 0,
          overrideContract: true,
          comment: null
      },
      approveCertain: false,
      factor: 1,
      employeePreferenceId:"",
      preferenceChangeId: "",
      error: false,
      
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
         this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        
        this.loadUIData()
        .then(response=> {
            view.updateUIData(response.data);
            return view.loadSpots();
        }).then(response => {
            view.updateSpots(response.data);
            return view.loadEmployees();
            
        }).then(response => {
            view.updateEmployees(response.data);
            return view.loadEmployeePreferences();
              
        }).then(response => {
            view.updateEmployeePreferences(response.data);
            return view.loadPreferenceChanges();      
        }).then(response => {
            view.updatePreferenceChanges(response.data);
        }).catch(function (error) {
            console.log(error)
        });
        
        

       
    }, 
    createEmployeePreference: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/employeepreference';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

        let payload = {
          storeId: this.$store.state.storeId,
          exclusive: true,
          approved: true,
        }
        payload.factor = this.employeePreference.factor;
        payload.from = this.$helpers.convertDateTimeString(this.employeePreference.fromDate, this.employeePreference.fromTime);
        payload.to = this.$helpers.convertDateTimeString(this.employeePreference.toDate, this.employeePreference.toTime);
        if(!this.$helpers.isBlank(this.employeePreference.employeeId)){
            payload.employeeId = this.employeePreference.employeeId
        }
        if(!this.$helpers.isBlank(this.employeePreference.spotId)){
            payload.spotId = this.employeePreference.spotId
        }
        if(!this.$helpers.isBlank(this.employeePreference.comment)){
            payload.comment = this.employeePreference.comment
        }
        payload.state = this.employeePreference.state;
        if(payload.state != 1){
            payload.type = null;
            payload.workValue = null;
        } else {
            payload.type = this.employeePreference.type;
            payload.workValue = this.employeePreference.workValue;
        }
        
        payload.overrideContract = this.employeePreference.overrideContract;

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            console.log(response)
            let employeePreferenceItem = {
                id: response.data.data.id,
                from: response.data.data.from,
                to: response.data.data.to,
                approved: response.data.data.approved,
                factor: response.data.data.factor,
                type: response.data.data.type,
                state: response.data.data.state,
                workValue: response.data.data.workValue,
            }
            if(!view.$helpers.isBlank(response.data.data.employeeId)){
                employeePreferenceItem.employee = view.employeeMap[response.data.data.employeeId].firstName+" "+view.employeeMap[response.data.data.employeeId].lastName;
            } else {
                employeePreferenceItem.employee = "";
            }
            if(!view.$helpers.isBlank(response.data.data.spotId)){
                employeePreferenceItem.spot = view.spotMap[response.data.data.spotId].name;
            } else {
                employeePreferenceItem.spot = "";
            }
            view.employeePreferenceMap[response.data.data.id] = response.data.data;
            view.employeepreferences.push(employeePreferenceItem);
            
            
            view.hideModal('modal-createemployeepreference');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    updateEmployeePreference: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/employeepreference';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

        let payload = {
          storeId: this.$store.state.storeId,
          id: this.employeePreferenceId,
          updateFields: []
        }
        let ofrom = this.$helpers.convertDateTimeString(this.employeePreference.fromDate, this.employeePreference.fromTime);
        let cfrom = this.$helpers.convertDateTimeString(this.employeePreferenceUpdate.fromDate, this.employeePreferenceUpdate.fromTime);
        if(ofrom != cfrom){
            payload.from = cfrom;
            payload.updateFields.push("from");
        }
        let oto = this.$helpers.convertDateTimeString(this.employeePreference.toDate, this.employeePreference.toTime);
        let cto = this.$helpers.convertDateTimeString(this.employeePreferenceUpdate.toDate, this.employeePreferenceUpdate.toTime);
        if(oto != cto){
            payload.to = cto;
            payload.updateFields.push("to");
        }
        if(this.employeePreference.factor != this.employeePreferenceUpdate.factor){
            payload.factor = this.employeePreferenceUpdate.factor;
            payload.updateFields.push("factor");
        }
        if(this.employeePreference.spotId != this.employeePreferenceUpdate.spotId){
            payload.spotId = this.employeePreferenceUpdate.spotId;
            payload.updateFields.push("spotId");
        }

         if(this.employeePreference.comment != this.employeePreferenceUpdate.comment){
            payload.comment = this.employeePreferenceUpdate.comment;
            payload.updateFields.push("comment");
        }

        if(this.employeePreference.overrideContract != this.employeePreferenceUpdate.overrideContract){
            payload.overrideContract = this.employeePreferenceUpdate.overrideContract;
            payload.updateFields.push("overrideContract");
        }

        if(this.employeePreference.state != this.employeePreferenceUpdate.state){
            payload.state = this.employeePreferenceUpdate.state;
            payload.updateFields.push("state");
            if(payload.state != 1){
                payload.workValue = null;
                payload.updateFields.push("workValue");
                payload.type = null;
                payload.updateFields.push("type");
            } else {
                payload.workValue =this.employeePreferenceUpdate.workValue;
                payload.updateFields.push("workValue");
                payload.type = this.employeePreferenceUpdate.type;
                payload.updateFields.push("type");
            }
        }
        
        
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.refresh();
            view.hideModal('modal-editemployeepreference');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    approveEmployeePreference: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/employeepreference/approve';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference/approve');
       
        let payload = {id: this.employeePreferenceId, certain: this.approveCertain, factor: this.factor};
        
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            const index = this.employeepreferences.findIndex(employeepreference => employeepreference.id === view.employeePreferenceId) 
            
            view.employeepreferences[index].approved=true;
            view.employeePreferenceMap[view.employeePreferenceId].approved = true;
              
            view.hideModal('modal-publishemployeepreference');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deleteEmployeePreference: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/employeepreference';
        
        url = this.$helpers.appendParam("id", this.employeePreferenceId, url, '/api/sec/employeepreference');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');
       
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.employeepreferences.findIndex(employeepreference => employeepreference.id === view.employeePreferenceId) 
            if (~index) {
                view.employeepreferences.splice(index, 1);
            }
            view.deleteEmployeePreferenceFromMap(view.employeePreferenceId);   
            view.hideModal('modal-deleteemployeepreference');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    approvePreferenceChange: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/preferencechange';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/preferencechange');
       
        let payload = {id: this.preferenceChangeId};
        
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.refresh();
              
            view.hideModal('modal-approvepreferencechange');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deletePreferenceChange: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/preferencechange';
        
        url = this.$helpers.appendParam("id", this.preferenceChangeId, url, '/api/sec/preferencechange');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/preferencechange');
       
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.preferenceChanges.findIndex(preferenceChange => preferenceChange.id === view.preferenceChangeId) 
            if (~index) {
                view.preferenceChanges.splice(index, 1);
            }
            view.deletePreferenceChangeFromMap(view.preferenceChangeId);   
            view.hideModal('modal-deletepreferencechange');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    openViewModal: function(id){
        
        this.employeePreferenceId = id;
      
        this.showModal('modal-viewemployeepreference');
    },
    openEditModal: function(id){
        
        this.employeePreferenceId = id;
        let preference = this.employeePreferenceMap[this.employeePreferenceId];
        
        if(!this.$helpers.isBlank(preference.employeeId)){
            this.employeePreference.employeeId = preference.employeeId;
            this.employeePreferenceUpdate.employeeId = preference.employeeId;
        }
       
        if(!this.$helpers.isBlank(preference.spotId)){
            this.employeePreference.spotId = preference.spotId;
            this.employeePreferenceUpdate.spotId = preference.spotId;
        }
        if(!this.$helpers.isBlank(preference.type)){
            this.employeePreference.type = preference.type;
            this.employeePreferenceUpdate.type = preference.type;
        }
        if(!this.$helpers.isBlank(preference.state)){
            this.employeePreference.state = preference.state;
            this.employeePreferenceUpdate.state = preference.state;
        }
        if(!this.$helpers.isBlank(preference.workValue)){
            this.employeePreference.workValue = preference.workValue;
            this.employeePreferenceUpdate.workValue = preference.workValue;
        }

        if(!this.$helpers.isBlank(preference.overrideContract)){
            this.employeePreference.overrideContract = preference.overrideContract;
            this.employeePreferenceUpdate.overrideContract = preference.overrideContract;
        }
        if(!this.$helpers.isBlank(preference.factor)){
            this.employeePreference.factor = preference.factor;
            this.employeePreferenceUpdate.factor = preference.factor;
        }
        if(!this.$helpers.isBlank(preference.from)){
            let fromDate = this.$helpers.extractDateString(preference.from);
            let fromTime = this.$helpers.extractDateString(preference.from, 'HH:mm');
            this.employeePreference.fromDate = fromDate ;
            this.employeePreferenceUpdate.fromDate = fromDate ;
            this.employeePreference.fromTime = fromTime ;
            this.employeePreferenceUpdate.fromTime = fromTime ;
        }
        if(!this.$helpers.isBlank(preference.to)){
            let toDate = this.$helpers.extractDateString(preference.to);
            let toTime = this.$helpers.extractDateString(preference.to, 'HH:mm');
            this.employeePreference.toDate = toDate ;
            this.employeePreferenceUpdate.toDate = toDate ;
            this.employeePreference.toTime = toTime ;
            this.employeePreferenceUpdate.toTime = toTime ;
        }

        
        
        this.showModal('modal-editemployeepreference');
    },
    openDeleteModal: function(id){

        this.employeePreferenceId = id;
        this.showModal('modal-deleteemployeepreference');
    },
    openPublishModal: function(id){
        this.employeePreferenceId = id;
        this.factor = this.employeePreferenceMap[this.employeePreferenceId].factor;
        this.showModal('modal-publishemployeepreference');
    },
    openDeletePreferenceChangeModal: function(id){
        this.preferenceChangeId = id;
        this.showModal('modal-deletepreferencechange');
    },
    openApprovePreferenceChangeModal: function(id){
        this.preferenceChangeId = id;
        this.showModal('modal-approvepreferencechange');
    },
    loadUIData: function(){
        let url = '/api/semi/uidata';
        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        });
    },
    loadSpots : function() {
      
      let url = '/api/sec/spot';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadPreferenceChanges : function() {
      
      let url = '/api/sec/preferencechange';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/preferencechange');
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadEmployees : function() {
      
      let url = '/api/sec/employee';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    updateUIData: function(data){
        this.uiData = data;
        let stateMap =  {};
        let typeMap = {};
        for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
            let employeeAvailabilityState = data.employeeAvailabilityStates[i];
            stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;   
        }
         for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
            let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
            typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;   
        }
        this.employeeAvailabilityStateMap = stateMap;
        this.employeeAvailabilityTypeMap = typeMap;
    },
    updateSpots: function(data){
        var i;
        let tspots = {}
        for (i = 0; i < data.length; i++) { 
            tspots[data[i].id] =data[i];
        }
        this.spotMap = tspots;
    },
    updateEmployees: function(data){
        var i;
        let temployees = {}
        for (i = 0; i < data.length; i++) {
            temployees[data[i].id] =data[i];
        }
        this.employeeMap = temployees;
    },
    updatePreferenceChanges: function(data){
        var i;
        let tpreferencechanges = {}
        let overviewB = [];
        for (i = 0; i < data.length; i++) {
            tpreferencechanges[data[i].id] =data[i];
            overviewB.push(this.createPreferenceChangeItem(data[i]));
        }
        this.preferenceChangeMap = tpreferencechanges;
        this.preferenceChanges = overviewB;
    },
    createPreferenceChangeItem: function(data){
        let item = {id: data.id, approved: data.approved, approvedBy: data.approvedBy, changeDate: this.$helpers.extractDateString(data.changeDate), responsible: data.responsible};
        item.from = this.employeePreferenceMap[data.preferenceId].from;
        item.to = this.employeePreferenceMap[data.preferenceId].to;
        if(!this.$helpers.isBlank(this.employeePreferenceMap[data.preferenceId].spotId)){
            item.spot = this.spotMap[this.employeePreferenceMap[data.preferenceId].spotId].name;
        } else {
            item.spot = "";
        }
        if(!this.$helpers.isBlank(this.employeePreferenceMap[data.preferenceId].employeeId)){
            item.employee = this.employeeMap[this.employeePreferenceMap[data.preferenceId].employeeId].firstName+" "+this.employeeMap[this.employeePreferenceMap[data.preferenceId].employeeId].lastName;
        } else {
            item.employee = "";
        }
        let changes = [];
        
        let change = {};
        if(data.changeDelta.spotId != undefined){
            change.label="Position";
            if(this.$helpers.isBlank(data.changeDelta.spotId)){
                change.newValue = "Keine Position";
            } else {
                change.newValue = this.spotMap[data.changeDelta.spotId].name
            }
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.from != undefined){
            change.label="Von";
            change.newValue = data.changeDelta.from;
            
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.to != undefined){
            change.label="Bis";
            change.newValue = data.changeDelta.to;
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.factor != undefined){
            change.label="Wichtigkeit";
            change.newValue = data.changeDelta.factor;
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.type != undefined){
            change.label="Typ";
            if(data.changeDelta.type == null){
                change.newValue = "Kein Typ";
            } else {
                change.newValue = this.employeeAvailabilityTypeMap[data.changeDelta.type].label_de
            }
            
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.state != undefined){
            change.label="Status";
            if(data.changeDelta.state == null){
                change.newValue = "Kein Status";
            } else {
                change.newValue = this.employeeAvailabilityStateMap[data.changeDelta.state].label_de
            }
            
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.workValue != undefined){
            change.label="Arbeitszeit";
            if(data.changeDelta.workValue == null){
                change.newValue = "Keine Arbeitszeit";
            } else {
                change.newValue = data.changeDelta.workValue + ' Minuten'
            }
            
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.overrideContract != undefined){
            change.label="Verfügbarkeit überschreiben";
            change.newValue = data.changeDelta.overrideContract;
            changes.push(change);
        }
        change = {};
        item.changes = changes;
        return item;

    },
    deleteEmployeePreferenceFromMap(id){
       
        for(var p in this.preferenceSkillMap){
            if(this.preferenceSkillMap[p].preferenceId === id){
                this.deleteShiftSkillFromMap(p);
            }
        }
        for(var p2 in this.preferenceChangeMap){
            if(this.preferenceChangeMap[p2].preferenceId === id){
                this.deletePreferenceChangeFromMap(p2);
            }
        }
        
        delete this.employeePreferenceMap[id];
    },
    deletePreferenceChangeFromMap(id){
        delete this.preferenceChangeMap[id]
    },
    loadEmployeePreferences : function() {
     
      let url = '/api/sec/employeepreference';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    updateEmployeePreferences: function(data) {
        let overviewA = [];
        var i;
        for (i = 0; i < data.length; i++) {
            this.employeePreferenceMap[data[i].id] = data[i]; 
            let employeePreferenceItem = {
                id: data[i].id,
                from: data[i].from,
                to: data[i].to,
                factor: data[i].factor,
                approved: data[i].approved,
                type: data[i].type,
                state: data[i].state,
                workValue: data[i].workValue,
            }
            if(!this.$helpers.isBlank(data[i].employeeId)){
                employeePreferenceItem.employee = this.employeeMap[data[i].employeeId].firstName+" "+this.employeeMap[data[i].employeeId].lastName;
            } else {
                employeePreferenceItem.employee = "";
            }
            if(!this.$helpers.isBlank(data[i].spotId)){
                employeePreferenceItem.spot = this.spotMap[data[i].spotId].name;
            } else {
                employeePreferenceItem.spot = "";
            }
            overviewA.push(employeePreferenceItem);
        }
      
        this.employeepreferences = overviewA;
    },
    hideModal (ref) {
        this.error = false;
        this.employeePreference = {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          factor: 1,
          state: 1,
          type: 4,
          workValue: 0,
          overrideContract: true,
          comment: null
          
        };
        this.employeePreferenceUpdate = {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          factor: 1,
          state: 1,
          type: 4,
          workValue: 0,
          overrideContract: true,
          comment: null
        };
        this.approveCertain = false;
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
  },
  computed: {
   
  },
  watch: { 
   

    }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>

</style>
